import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Объединение Tailwind-классов без конфликтов */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
